export default function EmptyOptionMenu() {
    return (
        <ul className="dropdown-menu"><li><a className="dropdown-item" href="." data-bs-toggle="modal" data-bs-target="#newTaskModal">Neue Aufgabe</a></li></ul>
    )
}